module.exports = __webpack_public_path__ + "static/media/OstomyWebTerms.b45b500f.txt";